/* The load-failure state, ported from renderLoadError (app.ts ~5156): a
   failure is an outcome, and outcomes are announced (MA16). The banner names
   what failed and why; the content and footnote clear, because nothing on the
   view is truthful without the data. */
import { useEffect, type JSX } from "react";
import { ViewFrame } from "./ViewFrame";
import { announce } from "./live";

export function LoadError({
  what,
  why = "The /api request failed — is the server healthy?",
}: {
  what: string;
  why?: string;
}): JSX.Element {
  useEffect(() => {
    announce(`Couldn't load ${what}.`);
    return () => announce("");
  }, [what]);
  return (
    <ViewFrame
      banner={
        <div className="banner">
          <b>Couldn't load {what}.</b>
          <span>{why}</span>
        </div>
      }
    />
  );
}
